<div class="card bg-dark-lighter text-white wallet-manual">
  <div
    class="card-header collapsed"
    data-bs-toggle="collapse"
    attr.data-bs-target="#{{ type }}Transaction"
    aria-expanded="false"
    attr.aria-controls="{{ type }}Transaction"
  >
    <span>{{ type.replace(re, " ") + " Transaction" | uppercase }}</span>
    <a
      class="btn-collapse collapsed ml-15"
      data-bs-toggle="collapse"
      attr.data-bs-target="#{{ type }}Transaction"
      aria-expanded="false"
      attr.aria-controls="{{ type }}Transaction"
    >
      <i class="fa fa-compress"></i>
      <i class="fa fa-expand"></i>
    </a>
    <button class="pull-right text-red fx-export-data" (click)="$event.stopPropagation(); $event.preventDefault(); exportExcel()" create-permission>
      Export
      <i class="fa fa-print"></i>
    </button>
  </div>
  <div class="card-body no-padder collapse" id="{{ type }}Transaction">
    <div class="p-3">
      <div class="row mb-15">
        <div class="col-md-6">
          <div
            class="input-group search-group"
            [ngClass]="{ loading: loading }"
          >
            <input
              type="text"
              class="form-control bg-dark"
              name="keyword"
              placeholder="Search Transaction"
              [(ngModel)]="condition.keyword"
            />
            <button
              class="btn btn-main"
              type="button"
              (click)="searchTransaction(true)"
            >
              Search
            </button>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="table-responsive">
            <table
              class="rox-table table-bordered bg-dark"
              id="tbl{{ type }}Transaction"
            >
              <thead>
                <tr>
                  <th class="text-center">ID</th>
                  <th class="text-center">User Name</th>
                  <th class="text-center">Email</th>
                  <th class="text-center" create-permission></th>
                </tr>
              </thead>
              <tbody>
                <tr
                  *ngFor="
                    let item of data
                      | paginate
                        : {
                            id: type,
                            itemsPerPage: pageInfo.pageSize,
                            currentPage: pageInfo.pageIndex,
                            totalItems: pageInfo.totalRecord
                          }
                  "
                >
                  <td class="text-center">{{ item.id }}</td>
                  <td class="text-center">{{ item.getUsername() }}</td>
                  <td class="text-center">{{ item.email }}</td>
                  <td class="text-center" create-permission>
                    <a
                      href="javascript:void(0)"
                      class="text-blue-lighter"
                      (click)="getManualInfo(item)"
                      data-bs-toggle="modal"
                      data-bs-target="#modalManualChangeAmount"
                      >View</a
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="row mt-15">
        <div class="col">
          <div class="pagination-wrapper">
            <pagination-controls
              id="{{ type }}"
              (pageChange)="pageChanged($event)"
              autoHide="true"
              responsive="true"
              previousLabel="Prev"
              nextLabel="Next"
            >
            </pagination-controls>
          </div>
        </div>
        <div class="col-auto">
          <span class="data-info"
            >Found: {{ pageInfo.totalRecord }}
            {{ pageInfo.totalRecord > 1 ? "records" : "record" }}</span
          >
        </div>
      </div>
    </div>
  </div>
  <!-- CHANGE AMOUNT MODAL -->
  <div class="modal fade fx-modal" id="modalManualChangeAmount" #modalUser>
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h2 class="modal-title font-bold" style="margin-bottom: 0">
            {{ itemManual.email + "  (" + itemManual.name + ")" }}
          </h2>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <table class="rox-table table-bordered bg-dark" *ngIf="itemManual.data">
            <thead>
              <tr>
                <th class="text-center">No</th>
                <th class="text-center">MT5 Account</th>
                <th class="text-center">Balance</th>
                <th class="text-center">Currency</th>
                <th class="text-center">Amount</th>
                <th class="text-center"></th>
                <th class="text-center"></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let item of itemManual.data; let i = index">
                <td class="text-center">{{ i }}</td>
                <td class="text-center">{{ item.login }}</td>
                <td class="text-center">
                  <span
                    labelNumber="{{ item.balance }}"
                    [currency]="item.currency"
                  ></span>
                </td>
                <td class="text-center">{{ item.currency | uppercase }}</td>
                <td class="text-center py-3 position-relative">
                  <input
                    type="text"
                    placeholder="Max value: 100.000.000.000"
                    [class.input-error]="item.amount > maxAmount"
                    [mask]="getFormatByCurrency(item.currency)"
                    [dropSpecialCharacters]="false"
                    [(ngModel)]="item.amount"
                    class="{{
                      submited && currentIndex == item.login && item.amount <= 0
                        ? 'invalid'
                        : ''
                    }} normal-input"
                  />
                  <div class="error-message" *ngIf="item.amount > maxAmount">Max value: 100.000.000.000</div>
                </td>
                <td class="text-center action-change-amount">
                  <button
                    class="btn btn-mainuce"
                    (click)="onChangeAmount('reduce', item)"
                  >
                    -
                  </button>
                  <button
                    class="btn btn-add"
                    (click)="onChangeAmount('add', item)"
                  >
                    +
                  </button>
                </td>
                <td class="text-center">
                  <a
                    href="javascript:void(0)"
                    class="text-blue-lighter"
                    (click)="getHisMT4Info(item)"
                    data-bs-toggle="modal"
                    data-bs-target="#modalHistoryAccountMT"
                    >View</a
                  >
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
  <!-- CHANGE HIS ACCOUNT MODAL -->
  <div class="modal fade fx-modal" id="modalHistoryAccountMT" #modalUser>
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <!-- Modal Header -->
        <div class="modal-header">
          <h2
            class="modal-title font-bold"
            style="margin-bottom: 0; text-transform: uppercase"
          >
            {{
              "MT5 - " +
                historyMT4Info.login +
                "  (" +
                historyMT4Info.currency +
                ")"
            }}
          </h2>
          <button
            type="button"
            class="close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            &times;
          </button>
        </div>

        <!-- Modal body -->
        <div class="modal-body">
          <table class="rox-table table-bordered bg-dark" *ngIf="historyMT4Info.data">
            <thead>
              <tr>
                <th class="text-center">No</th>
                <th class="text-center">Date</th>
                <th class="text-center">Amount</th>
                <th class="text-center">PIC</th>
                <th class="text-center">Email Sending Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let his of historyMT4Info.data; let i = index">
                <td class="text-center">{{ i }}</td>
                <td class="text-center">
                  {{ his.createTime | date: "yyyy/MM/dd" }}
                </td>
                <td class="text-center">
                  <span
                    labelNumber="{{ his.volume }}"
                    [currency]="historyMT4Info.currency"
                  ></span>
                </td>
                <td class="text-center">{{ his.username }}</td>
                <td class="text-center" [innerHTML]="his.getStatus()"></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
